import { createPolled } from "@solid-primitives/timer"
import { intlFormatDistance } from "date-fns"
import { type Accessor, createMemo } from "solid-js"
import { useI18nContext } from "@/i18n/i18n-solid"

export function useRelativeTime(
  date: Accessor<Date | string | number> | Date | string | number,
) {
  const { locale } = useI18nContext()

  const getDate = createMemo(() => {
    const d = typeof date === "function" ? date() : date
    return new Date(d)
  })

  return createPolled(
    () => intlFormatDistance(getDate(), new Date(), { locale: locale() }),
    1000,
  )
}
